import { render, staticRenderFns } from "./music_library_classify.vue?vue&type=template&id=d8c33302"
import script from "./music_library_classify.vue?vue&type=script&lang=js"
export * from "./music_library_classify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports